/**
 * Content Service - Loads dynamic content from backend
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Cache content data
let cachedContent = null;
let lastFetch = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const contentService = {
  /**
   * Get current site content from backend (with caching)
   */
  async getContent() {
    // Return cached data if fresh
    if (cachedContent && lastFetch && (Date.now() - lastFetch < CACHE_DURATION)) {
      return cachedContent;
    }

    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/content`);
      cachedContent = response.data;
      lastFetch = Date.now();
      return cachedContent;
    } catch (error) {
      console.error('Error fetching content:', error);
      
      // Return fallback content if API fails
      return this.getFallbackContent();
    }
  },

  /**
   * Fallback content (hardcoded defaults)
   */
  getFallbackContent() {
    return {
      hero: {
        headline: "So close to home.",
        description: "Buying a home is personal. We give you clear prices, honest market data and friendly AI tools that help you make a call you'll feel good about — without the jargon.",
        cta_button: "Find your home",
        badge_text: "VERIFIED IRISH LISTINGS"
      },
      advantages: {
        section_title: "Everything you need, nothing you don't",
        section_subtitle: "THE LOVINAHOME WAY",
        financial_transparency: {
          title: "The true cost, up front",
          description: "Purchase price + stamp duty + legal fees + repairs + monthly ownership, all in one place. No surprises after you sign."
        },
        ai_analysis: {
          title: "A second opinion you can trust",
          description: "Clear AI investment analysis in plain English: fair value, 5-year outlook, risk score and ROI."
        },
        blockchain: {
          title: "Listings we've checked",
          description: "Photos, measurements and BER ratings independently verified and timestamped — so what you see is what you get."
        },
        negotiation: {
          title: "Help when it matters",
          description: "Smart guidance on opening offers, counter-offers and walk-away prices from someone in your corner."
        },
        neighborhood: {
          title: "Know the neighbourhood",
          description: "Schools, transport, crime data and upcoming developments — 10 hours of research in a two-minute read."
        },
        virtual_tours: {
          title: "Walk through from the sofa",
          description: "Immersive 3D tours, virtual staging and honest condition reports before you book a viewing."
        },
        passport: {
          title: "A home for every home",
          description: "Your property passport tracks documents, maintenance and value for life — stays with the house, not the owner."
        }
      },
      footer: {
        company_description: "Friendly property search for Ireland. Real listings, real prices, real help.",
        contact_email: "hello@lovinahome.com",
        contact_phone: "+353 1 234 5678"
      }
    };
  },

  /**
   * Clear cache (call after admin updates content)
   */
  clearCache() {
    cachedContent = null;
    lastFetch = null;
  }
};

export default contentService;
